import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import { Grid, Paper } from "@mui/material";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { getSmartkioskInitialValues } from "app/pages/customers/dsok/utils/getSmartkioskInitialValues";
import SmartkioskProducts from "app/pages/customers/dsok/smartkioskFields/SmartkioskProducts";
import { SETTINGS_FIELD_SCHEMA } from "app/pages/customers/dsok/smartkioskFields/SmartkioskSettingsFields";
import { DSOK_CUSTOMER_FIELD_SCHEMA } from "app/pages/customers/dsok/smartkioskFields/SmartkioskCustomerFields";
import DsokCustomerDetailLayout from "../components/DsokCustomerDetailLayout";
import DsokCustomerDetailDirtySync from "../components/DsokCustomerDetailDirtySync";
import DsokCustomerDetailSectionRegister from "../components/DsokCustomerDetailSectionRegister";
import { useDsokCustomerDetail } from "../data/useDsokCustomerDetail";

const PRODUCTS_FIELD_NAME = "SMARTKIOSK_PRODUCTS";

const DsokCustomerProductsPage = () => {
  const { t } = useTranslation();
  const auth = useJumboAuth();
  const authUser = auth?.getAuthUser?.() || {};
  const userTyp = authUser?.type ?? authUser?.typ ?? 1;
  const isAdmin = userTyp === 1;

  const { customer } = useDsokCustomerDetail();
  const [expanded, setExpanded] = useState(PRODUCTS_FIELD_NAME);
  const handleChange = (panel) => (_event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const formInitialValues = useMemo(() => {
    if (!customer) {
      return {
        customer: { ...DSOK_CUSTOMER_FIELD_SCHEMA },
        settings: { ...SETTINGS_FIELD_SCHEMA },
      };
    }
    return getSmartkioskInitialValues(customer) ?? {
      customer: { ...DSOK_CUSTOMER_FIELD_SCHEMA },
      settings: { ...SETTINGS_FIELD_SCHEMA },
    };
  }, [customer]);

  return (
    <DsokCustomerDetailLayout
      lastBreadcrumbLabel={t("dsokCustomerDetail.sections.products.title")}
    >
      <Paper
        variant="outlined"
        sx={{
          bgcolor: "background.paper",
          p: 2,
          borderRadius: 1,
        }}
      >
        <Formik
          initialValues={formInitialValues}
          enableReinitialize
          onSubmit={() => {}}
        >
          <Form>
            <DsokCustomerDetailDirtySync />
            <DsokCustomerDetailSectionRegister
              sectionId="products"
              getPayload={(values) => values.settings?.smartkiosk?.productSettings ?? {}}
            />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SmartkioskProducts
                  handleChange={handleChange}
                  expanded={expanded}
                  hideSectionTitle
                />
              </Grid>
            </Grid>
          </Form>
        </Formik>
      </Paper>
    </DsokCustomerDetailLayout>
  );
};

export default DsokCustomerProductsPage;
